import { useState } from 'react';
import { useSnackbar } from 'notistack';
// components
import { Button } from "src/@/components/ui/button";
import Iconify from 'src/components/Iconify';
// actions
import v2_actionCriarTreinamentoUpload from 'src/actions/v2/ai/v2_actionCriarTreinamentoUpload';

// ----------------------------------------------------------------------

export default function SimpleDocumentUpload({ agentId, onCallback }) {
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
        }
    };

    const getTypeFromExtension = (filename) => {
        const ext = filename.split('.').pop().toLowerCase();
        if (ext === 'pdf') return 'pdfFile';
        if (ext === 'docx') return 'docxFile';
        if (ext === 'txt') return 'textFile';
        return null; // Unsupported
    };

    const handleUpload = async () => {
        if (!selectedFile) return;

        const docType = getTypeFromExtension(selectedFile.name);
        if (!docType) {
            enqueueSnackbar('Formato de arquivo não suportado. Use PDF, DOCX ou TXT.', { variant: 'error' });
            return;
        }

        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('type', 'documents');

            await v2_actionCriarTreinamentoUpload(agentId, formData);

            enqueueSnackbar('Arquivo enviado com sucesso!', { variant: 'success' });
            setSelectedFile(null);
            if (onCallback) onCallback();
        } catch (error) {
            console.error('Upload error:', error);
            enqueueSnackbar('Erro ao enviar arquivo.', { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col gap-4 w-full">
            <div
                className={`border-2 border-dashed rounded-xl p-8 flex flex-col items-center justify-center gap-3 transition-colors cursor-pointer ${selectedFile ? 'border-violet-500 bg-violet-50' : 'border-gray-300 hover:border-violet-400 hover:bg-gray-50'
                    }`}
                onClick={() => document.getElementById('simple-doc-upload').click()}
            >
                <input
                    id="simple-doc-upload"
                    type="file"
                    className="hidden"
                    accept=".pdf,.docx,.txt"
                    onChange={handleFileChange}
                />
                <div className={`p-3 rounded-full ${selectedFile ? 'bg-violet-100 text-violet-600' : 'bg-gray-100 text-gray-400'}`}>
                    <Iconify icon={selectedFile ? "solar:file-check-bold-duotone" : "solar:upload-track-bold-duotone"} width={32} />
                </div>
                <div className="text-center">
                    {selectedFile ? (
                        <>
                            <p className="text-sm font-semibold text-gray-900">
                                {selectedFile.name}
                            </p>
                            <p className="text-xs text-gray-500 mt-1">
                                {(selectedFile.size / 1024).toFixed(2)} KB - Pronto para enviar
                            </p>
                        </>
                    ) : (
                        <>
                            <p className="text-sm font-medium text-gray-900">
                                Clique para selecionar um arquivo
                            </p>
                            <p className="text-xs text-gray-500 mt-1">
                                Suporta PDF, DOCX e TXT
                            </p>
                        </>
                    )}
                </div>
            </div>

            {selectedFile && (
                <div className="flex justify-end gap-2 fade-in animate-in slide-in-from-top-2">
                    <Button variant="ghost" onClick={() => setSelectedFile(null)} disabled={loading} className="text-gray-500">
                        Cancelar
                    </Button>
                    <Button onClick={handleUpload} disabled={loading} className="bg-violet-600 hover:bg-violet-700 text-white min-w-[140px]">
                        {loading ? (
                            <>
                                <Iconify icon="svg-spinners:ring-resize" className="mr-2" />
                                Enviando...
                            </>
                        ) : (
                            <>
                                <Iconify icon="solar:upload-track-bold" className="mr-2" />
                                Enviar Arquivo
                            </>
                        )}
                    </Button>
                </div>
            )}
        </div>
    );
}